<template>
  <BaseLayout>
    <template v-slot:top_buttons>
      <div>
        <DocLink docKey="strategies" text="Помощь по разделу" />
        <div class="demo-inline-spacing">
          <button type="button" class="btn btn-primary" @click="createStrategy">
            Создать стратегию
          </button>
        </div>
      </div>
    </template>

    <div class="card">
      <div class="card-body">
        <div class="row gy-sm-1">
          <div class="col-md-3">
            <div class="input-group input-group-merge shadow-none">
              <input type="text" class="form-control border-1 py-2" placeholder="Поиск по названию"
                     v-model="searchData.name" @change="search">
            </div>
          </div>
          <div class="col-md-3">
            <Select v-model="searchData.store_id"
                    :options="[{ id: null, name: 'Не выбран' }, ...storesList]"
                    optionLabel="name"
                    optionValue="id"
                    placeholder="Магазин не выбран"
                    style="width: 100%"
                    @change="search">
              <template #option="slotProps">
                <div class="d-flex align-content-center">
                  <template v-if="slotProps.option.icon">
                    <img :src="slotProps.option.icon" alt="Маркетплейс" width="20px" style="margin-right: 3px">
                  </template>
                  <span>{{ slotProps.option.name }}</span>
                </div>
              </template>
            </Select>
          </div>
          <div class="col-md-3">
            <Select
              v-model="searchData.product_id"
              :options="productOptions"
              optionLabel="name"
              optionValue="id"
              placeholder="Поиск по товару"
              :filter="true"
              :filterInputProps="{ placeholder: 'Введите название или артикул' }"
              :loading="productLoading"
              @filter="onProductFilter"
              @change="search"
              style="width: 100%"
            >
              <template #option="slotProps">
                <span>{{ slotProps.option.name }}</span>
              </template>
            </Select>
          </div>
          <div class="col-md-2">
            <Select v-model="searchData.sort_by"
                    :options="sortByOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Сортировка по..."
                    style="width: 100%"
                    @change="search"/>
          </div>
          <div class="col-md-1">
            <Select v-model="searchData.sort_order"
                    :options="sortOrderOptions"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="--"
                    style="width: 100%"
                    @change="search"/>
          </div>
        </div>
        <div v-if="!strategies.length && !strategiesLoading" class="mt-7">
          Стратегии не найдены
        </div>
      </div>
      <LoadingBlock :loading="strategiesLoading">
        <div class="table-responsive text-nowrap">
          <table class="table" v-if="strategies.length">
            <thead>
              <tr>
                <th>Название стратегии</th>
                <th>Магазин</th>
                <th>Тип</th>
                <th style="text-align: right">Действия</th>
              </tr>
            </thead>
            <tbody class="">
            <tr v-for="(strategy, index) in strategies" :key="index">
              <td>
                <a href="#" @click.prevent="editStrategy(strategy)">
                  <span>{{ strategy.name }}</span>
                  <span v-if="isAutoRun(strategy)" v-tooltip.bottom="'Автоматический запуск по расписанию'" style="margin-left: 6px;">
                  <i class="ti ti-clock ti-md ti-small" style="margin-bottom: 4px;"></i>
                </span>
                </a>
                
              </td>
              <td v-if="getStoreById(strategy.store_id)">
                <span style="display: flex; align-items: center;">
                  <img :src="getStoreById(strategy.store_id).icon" width="20px" style="margin-right: 6px">
                  {{ getStoreById(strategy.store_id).name }}
                </span>
              </td>
              <td v-else>—</td>
              <td>{{ getProductSelectionTypeName(strategy.product_selection_type) }}</td>
              <td style="text-align: right">
                <button type="button" class="btn btn-icon btn-label-primary waves-effect d-inline-block m-1"
                        @click="editStrategy(strategy)">
                  <span class="ti ti-edit ti-md"></span>
                </button>
                <button type="button" class="btn btn-icon btn-label-secondary waves-effect d-inline-block"
                        @click="deleteStrategy(strategy.id)">
                  <span class="ti ti-trash ti-md"></span>
                </button>
              </td>
            </tr>
            </tbody>
          </table>

          <BasePagination :info="paginationInfo" ref="strategiesPagination" @changePage="changePage">
          </BasePagination>
        </div>
      </LoadingBlock>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/layouts/Base.vue'
import {PageInfo} from "@/data/page";
import {user} from "@/data/user";
import {subscription} from "@/data/subscription";
import router from "@/router";
import {deleteStrategy, getStrategies} from "@/api/strategies";
import BasePagination from "@/components/list/Pagination.vue"
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {stores} from "@/data/store";
import {Select} from "primevue";
import {getProducts} from "@/api/product";
import Tooltip from 'primevue/tooltip';
import DocLink from "@/components/tools/DocLink.vue";

export default {
  name: 'StrategiesView',
  components: {LoadingBlock, BaseLayout, BasePagination, Select, DocLink},
  directives: { tooltip: Tooltip },
  data() {
    return {
      strategies: [],
      searchResultReady: false,
      strategiesLoading: true,
      paginationInfo: {},
      searchData: {
        name: '',
        store_id: null,
        product_id: null,
        sort_by: null,
        sort_order: null
      },
      storesList: [],
      productOptions: [],
      productLoading: false,
      sortByOptions: [
        { value: 'name', label: 'Название' },
        { value: 'store_id', label: 'Магазин' },
        { value: 'created_at', label: 'Дата создания' },
        { value: 'last_run', label: 'Время последнего запуска' }
      ],
      sortOrderOptions: [
        { value: 'asc', label: '↑' },
        { value: 'desc', label: '↓' }
      ],
      productSelectionTypeNames: {
        by_id: 'Вручную',
        by_filter: 'Автоматически (по фильтрам)'
      }
    }
  },
  methods: {
    async getStrategies() {
      this.strategiesLoading = true
      const result = await getStrategies(user.active_company, this.$route.query)
      this.paginationInfo = {
        total: result.data.total,
        pages: result.data.pages,
        page: result.data.page,
        size: result.data.size
      }
      this.strategies = result.data.items
      this.strategiesLoading = false
    },
    async search() {
      const query = {...this.$route.query}
      delete query.page
      Object.entries(this.searchData).forEach(([key, value]) => {
        if (value) {
          query[key] = value
        } else {
          delete query[key]
        }
      });
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...query
        }
      })

    },
    setSearch() {
      if (this.$route.query.name) {
        this.searchData.name = this.$route.query.name
      } else {
        this.searchData.name = ''
      }
      if (this.$route.query.store_id) {
        this.searchData.store_id = this.$route.query.store_id
      } else {
        this.searchData.store_id = null
      }
      if (this.$route.query.product_id) {
        this.searchData.product_id = this.$route.query.product_id
      } else {
        this.searchData.product_id = null
      }
      if (this.$route.query.sort_by) {
        this.searchData.sort_by = this.$route.query.sort_by
      } else {
        this.searchData.sort_by = null
      }
      if (this.$route.query.sort_order) {
        this.searchData.sort_order = this.$route.query.sort_order
      } else {
        this.searchData.sort_order = null
      }
    },
    async createStrategy() {
      this.$router.push({'name': 'strategy-add'})
    },
    async editStrategy(strategy) {
      this.$router.push({'name': 'strategy-edit', params: {id: strategy.id}})
    },
    async deleteStrategy(strategy_id) {
      if (confirm('Вы уверены, что хотите удалить стратегию?')) {
        await deleteStrategy(strategy_id)
        await this.getStrategies()
      }
    },
    async changePage(page) {
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: page
        }
      });
    },
    setPageInfo() {
      PageInfo.title = 'Стратегии ценообразования'
      PageInfo.breadcrumbs = [
        {
          title: 'Главная',
          link: '/'
        },
        {
          title: PageInfo.title
        }
      ]
    },
    getStoreById(store_id) {
      return this.storesList.find(store => store.id === store_id);
    },
    getProductSelectionTypeName(type) {
      return this.productSelectionTypeNames[type] || type;
    },
    async onProductFilter(event) {
      const search = event.value;
      if (!search || search.length < 2) {
        this.productOptions = [];
        return;
      }
      this.productLoading = true;
      try {
        const result = await getProducts(await user.getActiveCompany(), { name: search, size: 20 });
        this.productOptions = result.data.items;
      } finally {
        this.productLoading = false;
      }
    },
    isAutoRun(strategy) {
      if (!strategy.schedule) return false;
      if (strategy.schedule.rule && Array.isArray(strategy.schedule.value) && strategy.schedule.value.length > 0) return true;
      return false;
    }
  },
  async mounted() {
    this.setPageInfo()
    this.setSearch()
    await user.getUserBase()
    
    // Проверка активности тарифа
    const isActive = await subscription.isActive()
    if (!isActive) {
      await router.push({ name: 'payment', query: { error: 'expired' } })
      return
    }
    
    this.storesList = await stores.getStores();
    await this.getStrategies()
  },
  watch: {
    '$route'() {
      this.setSearch()
      this.setPageInfo()
      this.getStrategies()
    }
  }
}
</script>